var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanificar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.9482 72.8012V82.8382H62.6902V90.3511C62.6902 93.0885 63.3686 95.6511 64.4848 97.9673H59.1876L32.3879 80.3513C28.4188 77.7392 23.3543 77.5204 19.1663 79.7761C17.1147 80.8809 15.4006 82.5208 14.2062 84.5217C13.0118 86.5225 12.3817 88.8095 12.3828 91.1397C12.3828 95.5506 14.5972 99.6092 18.3062 101.996L51.1696 123.158H97.9482V128.191H123.113V72.8012H97.9482ZM54.1285 113.091L23.7547 93.5317C23.3539 93.2746 23.0243 92.9207 22.7962 92.5027C22.5682 92.0847 22.4492 91.6159 22.4501 91.1397C22.4501 89.6094 23.4946 88.8786 23.9447 88.635C24.3975 88.3969 25.5796 87.9221 26.8596 88.7602L56.1764 108.033H87.9264V97.9673H87.8287V97.9618H80.3694C77.0692 97.9618 74.2506 95.8479 73.1978 92.9041H97.9496V113.091H54.1285ZM113.047 118.124H108.014V82.8671H113.047V118.124ZM29.2625 66.5077C26.4467 61.5945 24.959 55.9821 24.959 50.2748C24.959 32.2363 39.6311 17.56 57.6641 17.56C75.7012 17.56 90.372 32.2363 90.372 50.2748C90.372 55.9766 88.8857 61.589 86.0712 66.5022L94.8049 71.5062C98.4918 65.0695 100.438 57.7286 100.438 50.2748C100.438 26.6846 81.2488 7.4928 57.6641 7.4928C34.0794 7.4928 14.8931 26.6846 14.8931 50.2748C14.8931 57.7341 16.8419 65.0764 20.5288 71.5103L29.2625 66.5077Z",
    fill: "#E0BA56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5805 45.7608L36.8672 53.2586L55.6846 70.1135L79.1304 43.1432L71.5307 36.5372L54.7901 55.8006L43.5805 45.7608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanificar);
export default __webpack_public_path__ + "static/media/Planificar.9b1e1eaadc606e0208978e5bb0b84d37.svg";
export { ForwardRef as ReactComponent };